"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeRateApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
const data_lib_2 = require("@redbox-ruby/data-lib");
const EXCHANGE_RATE_CACHE = "exchange-rate";
function exchangeRateApiClient(networkClient) {
    const getExchangeRate = async (query) => {
        if (query.in === query.out) {
            return {
                timestamp: (0, data_lib_2.now)(),
                in: query.in,
                out: query.out,
                rate: 1,
            };
        }
        // We just care about the data for caching purposes
        const startOfDay = (0, data_lib_2.timestampToDate)(query.timestamp ?? (0, data_lib_2.now)());
        startOfDay.setUTCHours(0, 0, 0, 0);
        const date = startOfDay.toUTCString();
        const cacheKey = `${EXCHANGE_RATE_CACHE}-${query.in}-${query.out}-${date}`;
        return networkClient.cacheProvider.getOrCalculate(cacheKey, async () => {
            return networkClient.getHttp(data_lib_2.BUDGETS_WEB_SERVICE, `/api/v2/budgets/exchange-rates/rate`, query);
        });
    };
    const convert = async (amount, input, output) => {
        const exchangeRate = await getExchangeRate({ in: input, out: output });
        return (0, data_lib_1.roundMoney)(amount * exchangeRate.rate);
    };
    return {
        convert,
        getExchangeRate,
        convertAppleMoney: (apple, output) => {
            return convert((0, data_lib_1.fromMoneyString)(apple.amount), (0, data_lib_1.fromAppleCurrency)(apple.currency), output);
        },
        listExchangeRateOverPeriod: async (query) => {
            return networkClient.getHttp(data_lib_2.BUDGETS_WEB_SERVICE, `/api/v2/budgets/exchange-rates/period`, query);
        },
        convertFromAppleMoney: async (money, toCurrency) => {
            if (money == null) {
                return undefined;
            }
            return convert((0, data_lib_1.fromMoneyString)(money.amount), (0, data_lib_1.fromAppleCurrency)(money.currency), toCurrency);
        },
        convertToAppleMoney: async (money, fromCurrency, toCurrency) => {
            if (money == null) {
                return undefined;
            }
            const amount = await convert(money, fromCurrency, toCurrency);
            return (0, data_lib_1.toAppleMoney)(amount, (0, data_lib_1.toAppleCurrency)(toCurrency));
        },
    };
}
exports.exchangeRateApiClient = exchangeRateApiClient;
